import { connect } from 'react-redux';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { fetchMessageVolumeCoverageIfNeeded } from '../../actions/policy-progress-action-creators';
import { messageVolumeCoverageIsLoadingSelector } from '../../selectors/message-volume-coverage-selectors';
import {
    reportHeaderSelector,
    selectedDomainTypeSelector,
    selectedEndDateSelector,
    selectedIntervalSelector,
    selectedStartDateSelector
} from '../../selectors/reports-selectors';
import MessageVolumeCoverageProgressBulletsContainer from
    './message-volume-coverage-progress-bullets-container';
import MessageVolumeCoverageVisContainer from
    './message-volume-coverage-vis-container';
import MessageVolumeTableContainer from './message-volume-table-container';
import ReportingCard from '../../components/reporting-card';

export class MessageVolumeCoverageSectionContainer extends Component{
    componentDidMount(){
        const { onInitialLoad, fetchMessageVolumeCoverageIfNeeded } = this.props;

        onInitialLoad();
        fetchMessageVolumeCoverageIfNeeded();
    }

    componentDidUpdate(){
        const { fetchMessageVolumeCoverageIfNeeded } = this.props;

        fetchMessageVolumeCoverageIfNeeded();
    }

    render(){
        const { messageVolumeDataIsLoading, header } = this.props;

        return (
            <ReportingCard
                header={ header }
                dataIsLoading={ messageVolumeDataIsLoading }
                allowDownload={ true }
                type={ 'messageVolume' }
                order={ 2 }
                content={{
                    footer: '* p=reject or p=quarantine policies',
                    leftContent: <MessageVolumeCoverageProgressBulletsContainer />,
                    legend: {
                        dotLabel: 'Authorized Email Protected (%)',
                        streamLabel: 'Authorized Email Volume'
                    },
                    rightContent: <MessageVolumeCoverageVisContainer
                        isLoading={ messageVolumeDataIsLoading }
                    />,
                    subtitle: 'Emails sent to consumer mailbox providers',
                    table: <MessageVolumeTableContainer />,
                    textheader: 'How much of our authorized email to consumer mailbox providers was protected via (DMARC) blocking* policies?',
                    title: 'Authorized Email Protection Rate',
                }}
            />
        );
    };
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        header: reportHeaderSelector( state ),
        messageVolumeDataIsLoading: messageVolumeCoverageIsLoadingSelector( state ),
        selectedDomainType: selectedDomainTypeSelector( state ),
        selectedEndDate: selectedEndDateSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
        selectedStartDate: selectedStartDateSelector( state ),
    };
};

MessageVolumeCoverageSectionContainer.propTypes = {
    fetchMessageVolumeCoverageIfNeeded: PropTypes.func.isRequired,
    header: PropTypes.shape( {
        domain: PropTypes.string,
        domainType: PropTypes.string,
        endDate: PropTypes.string.isRequired,
        interval: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    } ),
    messageVolumeDataIsLoading: PropTypes.bool.isRequired,
    onInitialLoad: PropTypes.func.isRequired,
    selectedDomainType: PropTypes.string,
    selectedEndDate: PropTypes.string.isRequired,
    selectedInterval: PropTypes.string,
    selectedStartDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, {
    fetchMessageVolumeCoverageIfNeeded
} )( MessageVolumeCoverageSectionContainer );
